import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type CollectionDatum } from 'domains/collections/types/collections.types'
import { collectionStatusMessage } from 'domains/collections/utils/collections.utils'

interface Props {
  collection: CollectionDatum
}

export const CollectionsListStatusCell: FunctionComponent<Props> = ({ collection }) => {
  const status = useDomainMessage(collectionStatusMessage(collection))

  return <Text>{status}</Text>
}
